module.exports = __webpack_public_path__ + "img/AIRTEL.438440bc.svg";